import { IRobotConnection } from '../../db/types';
import { UseNewSimulatorStorage } from '../../db/local_storage';

export const useNewSimulator = () => UseNewSimulatorStorage.get();

export const getNewSimRobotConnection = (): IRobotConnection => {
  const defaultRobotConnection: IRobotConnection = {
    hostname: 'localhost',
    endpoint: '/',
    port: 9090,
    insecure: true,
  };

  return defaultRobotConnection;
};
